<template>
    <simple-layout
        :modelsLoaded="true"
        :indicators="indicators"
        :img="backgroundFile2"
        :name="getVerbose('alert_simple_layout_breadcrumb')"
    >
        <ns-loader
            :to-load="toLoad"
            :scoped="$store.getters.userIsAtLeastAdmin ? false : true"
            :dark="true"
            @dataFetched="onDataFetched"
        >
            <div slot="content" class="box alerts-container" :class="{'dark-theme': darkMode}">
                <div
                    class="box-body"
                    style="min-height: 200px;"
                >
                    <template>
                        <el-tabs
                            v-if="$store.getters.userIsAtLeastManager"
                            class="tables-container"
                        >
                            <el-tab-pane :label="`${getVerbose('alert_tab_panel_active_alert_title')} (${activeAlerts})`">
                                <alerts-table
                                    :acquited="false"
                                    :archived="false"
                                    :alertsLength="activeAlerts"
                                ></alerts-table>
                            </el-tab-pane>
                            <el-tab-pane :label="`${getVerbose('alert_tab_panel_inactive_alert_title')} (${inactivedAlerts})`">
                                <alerts-table
                                    :acquited="true"
                                    :archived="false"
                                    :alertsLength="inactivedAlerts"
                                ></alerts-table>
                            </el-tab-pane>
                            <el-tab-pane :label="`${getVerbose('alert_tab_panel_archived_alert_title')} (${archivedAlerts})`">
                                <alerts-table
                                    :acquited="true"
                                    :archived="true"
                                    :alertsLength="archivedAlerts"
                                ></alerts-table>
                            </el-tab-pane>
                        </el-tabs>
                        <div
                            v-else
                            class="title-alerts-page"
                        >
                            {{ getVerbose('alert_no_permission') }}
                        </div>
                    </template>
                </div>
            </div>
            <div slot="error" class="alerts-fetch-error">
                <el-alert
                    :closable="false"
                    effect="dark"
                    title="Error"
                    description="An unexpected error occured while fetching alerts"
                    type="error"
                    show-icon
                >
                </el-alert>
            </div>
        </ns-loader>
    </simple-layout>
</template>

<script>
import SimpleLayout from '../../partials/simple-layout.vue';
import AlertsTable from './AlertsTable.vue';
import {mapGetters} from 'vuex';
import NsLoader from '../../partials/ns-vue-loader.vue';
export default {

    components: { AlertsTable , NsLoader, SimpleLayout},
    data (){
        return {
            activeAlerts: 0,
            inactivedAlerts: 0,
            archivedAlerts: 0,
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'burgerMenuAllowedAndClosed',
            'backgroundFile2',
            'getVerbose',
            'activeAlertsFetchFilter',
            'inactivedAlertsFetchFilter',
            'archivedAlertsFetchFilter',
            'darkMode',
        ]),
        toLoad (){
            return [
                { model: 'alerts',name: 'activeAlerts', stats: true, filters: this.activeAlertsFetchFilter },
                { model: 'alerts',name: 'inactivedAlerts', stats: true, filters: this.inactivedAlertsFetchFilter },
                { model: 'alerts',name: 'archivedAlerts', stats: true, filters: this.archivedAlertsFetchFilter },
            ];
        },
        indicators() {
            return [
                {
                    title: this.activeAlerts,
                    subtitle: this.getVerbose('alert_simple_layout_active_alert_indicator'),
                },
                {
                    title: this.inactivedAlerts,
                    subtitle: this.getVerbose('alert_simple_layout_inactive_alert_indicator'),
                },
            ];
        },
    },

    methods: {
        onDataFetched (res){
            this.$set(this, 'activeAlerts',res.activeAlerts );
            this.$set(this, 'inactivedAlerts',res.inactivedAlerts );
            this.$set(this, 'archivedAlerts',res.archivedAlerts );
        }
    }
};
</script>

<style lang="scss" module>
.settingsHeader{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 65px;
}
</style>

<style lang="scss">

.alerts-container {
    margin-top: 30px;
    margin-bottom: 0;
    &.dark-theme {
        background-color: #111111 !important;
        color: #bbb !important;
    }
    .tables-container {
        margin: 0 20px;
        .el-tabs__item {
            color: #EAEBEF;
            &.is-active {
                color: #409EFF;
            }
        }
    }
}
.alerts-fetch-error{
    margin-top: 15px;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/alerts/index.vue